<template>
  <div class="word_pk_page">
    <div class="word_pk_set_words">
      <div class="word_pk_set_words-hd">
        <div class="navigation">
          <div class="left">
            <div style="" class="back-btn" @click="backRoute"></div>
          </div>
          <div class="center" v-if="article">选择章节-{{ article.ch_title }}</div>
          <div class="right"></div>
        </div>
      </div>
      <div class="word_pk_set_words-bd">
        <div class="items">
          <div class="card_wrap" v-for="(item,index) in items" v-bind:key="index">
            <div class="card" @click="to_detail(item.id)">
              <div class="text">第{{ item.chapters }}章 {{ item.chapters_en }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { http } from '@/utils/request'
import { getFamousChapter } from '../../services'


export default {
  name: 'famous_read_book',
  components: {},
  data () {
    return {
      title: '',
      article: '',
      items: [],
    }
  },
  created () {
    this.init()
  },
  methods: {
    to_detail (id) {
      this.$router.push({
        path: '/famous_read/detail',
        query: {
          book_id: id,
        }
      })
    },
    async init () {
      await getFamousChapter({
        id: this.$route.query.book_id,
      }).then((res) => {
        this.items = res.data.list
        this.article = res.data.article
      })
    },
    async getData (params) {
      return http.post({
        url: '/recreation/chapter_v2?size=100',
        params
      })
    },
    backRoute () {
      this.$router.back();
    }
  },
}
</script>
<style lang="less" scoped>
.word_pk_page {
  display: block;
  height: 100%;
  width: 100%;
}

.word_pk_set_words {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-size: 1620px 817px;
  background: url(~assets/lvbg.png) no-repeat center center;
}

.active_color {
  color: #27BF95;
  font-weight: bold;
}

.word_pk_set_words-hd {
  display: flex;
  flex-direction: column;
}

.ui-tab-content {
  display: block;
  height: 100%;
  width: 100%;
}

.navigation {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  width: 100%;
  height: 60px;
  background-color: #fff;
  text-align: center;
  padding: 0 40px;

  .left {
    flex: 1;
    display: flex;
    text-align: right;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .center {
    flex: 1;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }

  .right {
    flex: 1;
    display: flex;
    text-align: right;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
  }
}

.word_pk_set_words-bd {
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100vh - 80px);
  overflow: auto;
}

.word_pk_set_words_tool_wrap {
  padding: 1rem 1.5rem;
  background: #FBFBFB;

  .word_pk_set_words_tool {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    width: 860px;
    margin: 0 auto;
    align-items: center;

    .word_pk_set_words_tool_group {
      display: flex;

      &.merge_btn {
        .ui-btn {
          margin: 0;
          min-width: auto;

          &:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          &:last-child {
            border-left: none;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }

    .ui-btn {
      margin: 0 .5rem;
    }
  }
}


.back-btn {
  display: block;
  width: 30px;
  height: 27px;
  background: url(~assets/word/back-icon.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

.ui-btn {
  &.ui-btn_primary {
    border-color: transparent;
    color: #fff;
    background: linear-gradient(360deg, #47cbb3 0%, #51d3b0 100%);
    box-shadow: 0 5px 10px rgba(59, 201, 164, 0.03);
    border-radius: 30px;
  }

  &.basic {
    border: none;
    border-radius: 0;
    padding: 0;
    justify-content: flex-start;
  }

  cursor: pointer;
  font-weight: 400;
  min-width: 96px;
  font-size: 1rem;
  padding: 0.5rem 0.6rem;
  border-radius: 25px;
  border: 1px solid #EDEDED;
  display: flex;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: Microsoft YaHei;

  .tool_column_line {
    display: block;
    height: 1rem;
    width: 1px;
    margin: 0 .25rem;
    background: #cDcDcD;
  }

  .ui-btn_checkbox {
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 4px;
    border: 1px solid #ADADAD;

    &.active {
      background: #27BF95;
      border-color: #27BF95;
    }

  }

  .ui-btn_text {
    color: inherit;
    padding: 0 .2256rem;
    text-align: center;
    position: relative;

    .ab-right {
      position: absolute;
      left: 100%;
    }
  }
}

.items {
  display: block;
  width: 900px;
  margin: 1rem auto 0;

  .card_wrap {
    display: block;
    float: left;
    width: 50%;
    padding: .5rem;
    box-sizing: border-box;

    &.active {
      .card {
        border-color: #27BF95;
        background: #27BF95;

        .text {
          //color: #27BF95;
          color: #fff;
        }

        .secondary-text {
          opacity: .8;
          //color: #27BF95;
          color: #fff;
        }
      }
    }

    .card {
      .text {
        padding-left: 4rem;
        text-align: left;
        height: 60px;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        flex-direction: column;
      }

      width: 100%;
      cursor: pointer;
      background: #fff;
      padding: 0;
      border-radius: 5px;
      display: flex;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .text {
        font-size: 1rem;
      }

      .secondary-text {
        color: rgba(0, 0, 0, .5);
        font-size: .8rem;
      }
    }
  }
}

.submit-btn {
  display: inline-block;
  min-width: 140px;
  height: 46px;
  line-height: 46px;
  margin-left: .5rem;

  .ui-btn {
    padding: 0;
  }
}

</style>